import { useState, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { CustomSelect, GradeOptions, RegistrationStatusOptions, StudentSexOptions } from "../../../../../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import KTImageInput from "../../../../../../_metronic/_assets/js/components/image-input";

export function StudentBasicInfoForm({
  sections,
  student,
  handleChange,
  setFieldValue,
  values,
  getSections
 }) {
  const [photo, setPhoto] = useState("");
  const registrationDate = values.registrationDate != null ? values.registrationDate : "";
  const studentNumber = values.studentNumber != null ? values.studentNumber : "";
  const birthDate = values.identityCard.birthDate != null ? values.identityCard.birthDate : "";

  useEffect(() => {
    student.photoStr ? setPhoto(student.photoStr) : setPhoto("");
  }, [student]);

  const getStudentPhoto = () => {
    if (!photo) {
      return "none";
    }

    return `url(${photo})`;
  };

  const removePhoto = () => {
    setPhoto("");
  };

  new KTImageInput("student_photo");

  return (
    <>
      <div className="row">
        <div className="col-6">
        <Form.Group as={Row} controlId="photo">
            <Form.Label column sm={3}>
              Fotoğraf
            </Form.Label>
            <Col sm={9}>
              <div
                className="image-input image-input-outline"
                id="student_photo"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/users/blank.png"
                  )}`,
                }}
              >
                <div
                  className="image-input-wrapper"
                  style={{ backgroundImage: `${getStudentPhoto()}`}}
                />
                <label
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="change"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Change photo"
                >
                  <i className="fa fa-pen icon-sm text-muted"></i>
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={e => setFieldValue("photoFile", e.target.files[0])}
                  />
                  <input type="hidden" name="student_photo_remove" />
                </label>
                <span
                  onClick={e => setFieldValue("photoFile", null)}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="cancel"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Cancel photo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
                <span
                  onClick={removePhoto}
                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="remove"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Remove photo"
                >
                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                </span>
              </div>
              <span className="form-text text-muted">
                İzin Verilen Dosya Türleri: png, jpg, jpeg.
              </span>
            </Col>
          </Form.Group>
        </div>
      </div>

      <div className="row">
        <div className="col-6">
          <Form.Group as={Row} controlId="registrationNo">
            <Form.Label column sm={3}>
              Kayıt No
            </Form.Label>
            <Col sm={9}>
              <Form.Control value={values.registrationNo} readOnly />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="registrationDate">
            <Form.Label column sm={3}>
              Kayıt Tarihi
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="date" value={registrationDate} placeholder="Kayıt Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="studentNumber">
            <Form.Label column sm={3}>
              Öğrenci Numarası
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="number" min="1" value={studentNumber} placeholder="Öğrenci Numarası" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="identityCard.tcKimlikNo">
            <Form.Label column sm={3}>
              TC Kimlik No
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.identityCard.tcKimlikNo} placeholder="TC Kimlik No" onChange={handleChange} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row} controlId="identityCard.name">
            <Form.Label column sm={3}>
              Adı <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.identityCard.name} placeholder="Adı" onChange={handleChange} />
            </Col>
          </Form.Group>
                    
          <Form.Group as={Row} controlId="identityCard.surname">
            <Form.Label column sm={3}>
              Soyadı <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.identityCard.surname} placeholder="Soyadı" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="sex">
            <Form.Label column sm={3}>
              Cinsiyeti <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={StudentSexOptions}
                value={values.sex}
                onChange={option => setFieldValue("sex", option.value)}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="identityCard.birthDate">
            <Form.Label column sm={3}>
              Doğum Tarihi
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="date" value={birthDate} placeholder="Doğum Tarihi" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>

        <div className="col-6">
          <Form.Group as={Row} controlId="registrationStatus">
            <Form.Label column sm={3}>
              Kayıt Durumu <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={RegistrationStatusOptions}
                value={values.registrationInfo.registrationStatus}
                onChange={option => setFieldValue("registrationInfo.registrationStatus", option.value)}
              />
            </Col>
          </Form.Group>
                  
          <Form.Group as={Row} controlId="grade">
            <Form.Label column sm={3}>
              Sınıf <span>*</span>
            </Form.Label>
            <Col sm={9}>
              <CustomSelect
                options={GradeOptions}
                value={values.registrationInfo.grade}
                onChange={option => {
                  getSections(option.value);
                  handleChange("registrationInfo.grade")(option.value);
                }}
              />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="section">
            <Form.Label column sm={3}>
              Şube
            </Form.Label>
            <Col sm={9}>
              <CustomSelect 
                options={sections}
                value={values.registrationInfo.sectionId}
                onChange={option => setFieldValue("registrationInfo.sectionId", option.value)}
              />
            </Col>
          </Form.Group>              
          
          <Form.Group as={Row} controlId="theSchoolWhereComeFrom">
            <Form.Label column sm={3}>
              Geldiği Okul
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.theSchoolWhereComeFrom} placeholder="Geldiği Okul" onChange={handleChange} />
            </Col>
          </Form.Group>
          
          <Form.Group as={Row} controlId="phone">
            <Form.Label column sm={3}>
              Telefon
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.phone} placeholder="Telefon" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="email">
            <Form.Label column sm={3}>
              Email
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.email} placeholder="Email" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="facebook">
            <Form.Label column sm={3}>
              Facebook
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.facebook} placeholder="Facebook" onChange={handleChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="twitter">
            <Form.Label column sm={3}>
              Twitter
            </Form.Label>
            <Col sm={9}>
              <Form.Control type="text" value={values.twitter} placeholder="Twitter" onChange={handleChange} />
            </Col>
          </Form.Group>
        </div>
      </div>
    </>
  );
}